import styled, { css } from 'styled-components';

import { GenericSpan } from 'commonStyles';
import { ASSET_PATH } from 'assetsPath';

export const OrangeBorder = styled.div(
	({ theme: { down, breakpoints } }) => `
  border-radius: 18px;
  background: #F76162;
  margin-bottom: 24px;
  width: 52px;
  height: 10px;
  ${down(breakpoints.md)} {
    width: 30px; 
    height: 6px;
    margin-bottom: 10px;
  }
  `
);

export const StickyBottomBtn = styled.div`
	position: fixed;
	bottom: 0;
	width: 100%;
	z-index: 1;
	>button{
		border-radius: 0 !important;
	}
`;

export const PartnerIcons = styled(GenericSpan) `
    background: url(${ASSET_PATH.IMAGES}mice/miceLogoSprite.png) no-repeat;
    display: inline-block;  
		background-size: 400px 325px; 
		font-size: 0px; 
		flex-shrink: 0;
    ${(props) => {
		switch (props.icon) {
			case 'logoYamaha': {
				return css`
				background-position: -5px -11px;
				width: 97px;
				height: 21px;
				`;
			}
			case 'logoVivo': {
				return css`
				background-position: -111px -12px;
				width: 65px;
				height: 18px;
				`;
			}
			case 'logoVanHeusen': {
				return css`
				background-position: -185px -10px;
				width: 85px;
				height: 24px;
				`;
			}
			case 'logoTencent': {
				return css`
				background-position: -280px -11px;
				width: 112px;
				height: 22px;
				`;
			}
			case 'logoSunHeart': {
				return css`
				background-position: -7px -40px;
				width: 48px;
				height: 22px;
				`;
			}
			case 'logoSbiCard': {
				return css`
				background-position: -65px -44px;
				width: 127px;
				height: 24px;
				`;
			}
			case 'logoRedington': {
				return css`
				background-position: -200px -45px;
				width: 91px;
				height: 24px;
				`;
			}
			case 'logoRaychem': {
				return css`
				background-position: -301px -48px;
				width: 82px;
				height: 17px;
				`;
			}
			case 'logoPepsico': {
				return css`
				background-position: -10px -76px;
				width: 98px;
				height: 23px;
				`;
			}
			case 'logoPaytm': {
				return css`
				background-position: -119px -81px;
				width: 65px;
				height: 22px;
				`;
			}

			case 'logoNissin': {
				return css`
				background-position: -195px -83px;
				width: 50px;
				height: 24px;
				`;
			}
			case 'logoMiXiomi': {
				return css`
				background-position: -255px -84px;
				width: 76px;
				height: 23px;
				`;
			}
			case 'logoMaxInsurance': {
				return css`
				background-position:  -339px -85px;
				width: 42px;
				height: 24px;
				`;
			}
			case 'logoMamaearth': {
				return css`
				background-position: -10px -112px;
				width: 91px;
				height: 22px;
				`;
			}
			case 'logoLG': {
				return css`
				background-position: -110px -117px;
				width: 49px;
				height: 11px;
				`;
			}
			case 'logoPathLabs': {
				return css`
				background-position: -166px -115px;
				width: 94px;
				height: 22px;
				`;
			}
			case 'logoKenStar': {
				return css`
				background-position: -216px -250px;
 				width: 65px;
 				height: 24px;
				`;
			}
			case 'logoJagsonPal': {
				return css`
				background-position: -345px -116px;
				width: 19px;
				height: 24px;
				zoom: 1.5;
				`;
			}
			case 'logoJohnDeere': {
				return css`
				background-position: -11px -147px;
				width: 113px;
				height: 24px;
				`;
			}
			case 'logoJKLakshmi': {
				return css`
				background-position: -135px -150px;
				width: 79px;
				height: 24px;
				`;
			}
			case 'logoHoneywell': {
				return css`
				background-position: -225px -152px;
				width: 105px;
				height: 20px;
				`;
			}
			case 'logoGoogle': {
				return css`
				background-position: -11px -182px;
				width: 71px;
				height: 24px;
				`;
			}
			case 'logoEY': {
				return css`
				background-position: -91px -180px;
				width: 44px;
				height: 22px;
				`;
			}
			case 'logoDunzo': {
				return css`
				background-position: -140px -191px;
				width: 84px;
				height: 20px;
				`;
			}
			case 'logoCarrier': {
				return css`
				background-position: -236px -179px;
				width: 55px;
				height: 22px;
				`;
			}
			case 'logoHcl': {
				return css`
				background-position: -302px -179px;
				width: 89px;
				height: 13px;
				`;
			}
			case 'logoBML': {
				return css`
				background-position: -7px -215px;
				width: 115px;
				height: 22px;
				`;
			}
			case 'logoBlackberryGrey': {
				return css`
				background-position: -135px -221px;
				width: 138px;
				height: 22px;
				`;
			}
			case 'logoCitiBank': {
				return css`
				background-position: -305px -201px;
				width: 84px;
				height: 22px;
				`;
			}
			case 'logoBibaNew': {
				return css`
				background-position:  -290px -227px;
				width: 98px;
				height: 28px;
				`;
			}
			case 'logoPathLabNew': {
				return css`
				background-position:  -166px -115px;
				width: 94px;
				height: 24px;
				`;
			}
			case 'logoAxis': {
				return css`
				background-position: -10px -250px;
				width: 57px;
				height: 16px;
				`;
			}
			case 'logoAltBalaji': {
				return css`
				background-position: -80px -250px;
				width: 55px;
				height: 24px;
				`;
			}
			case 'logoAirtel': {
				return css`
				background-position: -143px -250px;
				width: 64px;
				height: 22px;
				`;
			}
			case 'logoEmmay': {
				return css`
				background-position: -12px -278px;
				width:  44px;
				height: 21px;
				`;
			}
			default:
				break;
		}
	}}
`;
